export enum UpdateState {
  Unchanged = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3,
};

export interface UpdateStateItem {
  state: UpdateState;
}
